import union from 'lodash/union';
import without from 'lodash/without';
import * as appProgressActions from 'actions/appProgress';

const initialState = {
  activators: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case appProgressActions.APP_PROGRESS_ACTIVATOR_ADD:
      return {
        activators: union(state.activators, [action.id])
      };

    case appProgressActions.APP_PROGRESS_ACTIVATOR_REMOVE:
      return {
        activators: without(state.activators, action.id)
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/appProgress.js